export enum MaintenanceTypeEnum {
    Preventive = 1,
    Repair = 2,
    Replacement = 3,
    Inspection = 4,
}
